import React from 'react';
import { CompanyDashboardProps, fillColor } from '../constants';
import { CustomizedTickProps } from './types';
import { buildBarChartLocationTickLines } from './tickLabelText';

export { splitTextBySpace } from './tickLabelText';

export const CustomizedTick: React.FC<CustomizedTickProps> = props => {
  const { x, y, payload } = props;

  const displayLines =
    typeof payload.value === 'string'
      ? buildBarChartLocationTickLines(payload.value)
      : [payload.value.toString()];

  return (
    <g transform={`translate(${x},${y})`}>
      {displayLines.map((line, index) => (
        <text
          key={index}
          x={0}
          y={index * 11}
          dy={5}
          dx={-35}
          fontSize={11}
          transform="rotate(-39)"
          textAnchor={CompanyDashboardProps.MIDDLE}
          fill={fillColor}>
          {line}
        </text>
      ))}
    </g>
  );
};
